import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import UsersPage from 'model/UsersPage'

export class UsersPagesRepository extends WebRepository<UsersPage> {
  constructor() {
    super(new Api('users'))
  }

  async searchUsersPage(bookmark: string): Promise<UsersPage> {
    return super.searchPage({
      selector: {},
      limit: 10,
      bookmark: bookmark,
    })
  }

  async searchUsersPageText(bookmark: string, text: string): Promise<UsersPage> {
    return super.searchPage({
      selector: {
        $or: [
          {
            userName: text,
          },
          {
            givenNameInit: {
              $regex: '(?i)' + text,
            },
          },
          {
            FamilyNameInit: {
              $regex: '(?i)' + text,
            },
          },
          {
            role: {
              $regex: '(?i)' + text,
            },
          },
          {
            speciality: {
              $regex: '(?i)' + text,
            },
          },
        ],
      },
      limit: 10,
      bookmark: bookmark,
    })
  }

  async searchUsersPageInGroup(groupId: string, bookmark: string): Promise<UsersPage> {
    return super.searchPage({
      groupId,
      selector: {},
      limit: 10,
      bookmark: bookmark,
    })
  }

  async searchUsersPageInGroupText(
    groupId: string,
    bookmark: string,
    text: string,
  ): Promise<UsersPage> {
    return super.searchPage({
      groupId,
      selector: {
        $or: [
          {
            userName: text,
          },
          {
            givenNameInit: {
              $regex: '(?i)' + text,
            },
          },
          {
            FamilyNameInit: {
              $regex: '(?i)' + text,
            },
          },
          {
            role: {
              $regex: '(?i)' + text,
            },
          },
          {
            speciality: {
              $regex: '(?i)' + text,
            },
          },
        ],
      },
      limit: 10,
      bookmark: bookmark,
    })
  }

  async searchUsersPageInMainGroup(bookmark: string): Promise<UsersPage> {
    return super.searchPage({
      mainGroup: true,
      selector: {},
      limit: 10,
      bookmark: bookmark,
    })
  }

  async searchUsersPagePageInMainGroupText(bookmark: string, text: string): Promise<UsersPage> {
    return super.searchPage({
      mainGroup: true,
      selector: {
        $or: [
          {
            userName: text,
          },
          {
            givenNameInit: {
              $regex: '(?i)' + text,
            },
          },
          {
            FamilyNameInit: {
              $regex: '(?i)' + text,
            },
          },
          {
            role: {
              $regex: '(?i)' + text,
            },
          },
          {
            speciality: {
              $regex: '(?i)' + text,
            },
          },
        ],
      },
      limit: 10,
      bookmark: bookmark,
    })
  }

  async searchUsersPageInSystem(bookmark: string): Promise<UsersPage> {
    return super.searchPage({
      system: true,
      selector: {},
      limit: 10,
      bookmark: bookmark,
    })
  }

  async searchUsersPagePageInSystemText(bookmark: string, text: string): Promise<UsersPage> {
    return super.searchPage({
      system: true,
      selector: {
        $or: [
          {
            userName: text,
          },
          {
            givenNameInit: {
              $regex: '(?i)' + text,
            },
          },
          {
            FamilyNameInit: {
              $regex: '(?i)' + text,
            },
          },
          {
            role: {
              $regex: '(?i)' + text,
            },
          },
          {
            speciality: {
              $regex: '(?i)' + text,
            },
          },
        ],
      },
      limit: 10,
      bookmark: bookmark,
    })
  }

  async searchUsersPageUnGrouped(bookmark: string): Promise<UsersPage> {
    return super.searchPage({
      unGrouped: true,
      selector: {},
      limit: 10,
      bookmark: bookmark,
    })
  }

  async searchUsersPagePageUnGrouped(bookmark: string, text: string): Promise<UsersPage> {
    return super.searchPage({
      unGrouped: true,
      selector: {
        $or: [
          {
            userName: text,
          },
          {
            givenNameInit: {
              $regex: '(?i)' + text,
            },
          },
          {
            FamilyNameInit: {
              $regex: '(?i)' + text,
            },
          },
          {
            role: {
              $regex: '(?i)' + text,
            },
          },
          {
            speciality: {
              $regex: '(?i)' + text,
            },
          },
        ],
      },
      limit: 10,
      bookmark: bookmark,
    })
  }
}

export default new UsersPagesRepository()
